export default __webpack_public_path__ + "static/bg_uams.jpg?45528ff4c48b";